import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Paper,
  Typography } from
'@mui/material';
import { DeduplicationTask } from 'crqlar-react-common/dist/models/profile/deduplicationTask.model';
import { formatDuration, formatNumber } from './deduplicationUtils';

interface MergingPhaseCardProps {
  task: DeduplicationTask;
}

const MergingPhaseCard: React.FC<MergingPhaseCardProps> = ({ task }) => {
  const { t } = useTranslation();
  if (!task.mergingStats) return null;
  const stats = task.mergingStats;

  return (
    <Card variant="outlined" sx={{ mb: 3, p: 2 }}>
            <CardContent>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>{t("Step 5: Merging")}

        </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>{t("Duration:")}
          {formatDuration(stats.durationMs)}
                </Typography>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ bgcolor: 'background.default' }}>
                            <Typography variant="h6" color="primary" gutterBottom>{t("Clusters Analyzed")}

              </Typography>
                            <Typography variant="h3" sx={{ fontWeight: 700 }}>
                                {formatNumber(stats.clustersAnalyzed)}
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ bgcolor: 'background.default' }}>
                            <Typography variant="h6" color="primary" gutterBottom>{t("Merged Profiles Created")}

              </Typography>
                            <Typography variant="h3" sx={{ fontWeight: 700 }}>
                                {formatNumber(stats.mergedProfilesCreated)}
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ bgcolor: 'background.default' }}>
                            <Typography variant="h6" color="primary" gutterBottom>{t("Profiles Marked Non-Live")}

              </Typography>
                            <Typography variant="h3" sx={{ fontWeight: 700 }}>
                                {formatNumber(stats.profilesMarkedAsNonLive)}
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>

                <Box sx={{ mt: 4 }}>
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>{t("Cluster Changes Breakdown")}

          </Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={6} md={3}>
                            <Typography variant="body2" color="text.secondary">{t("Unchanged Clusters")}

              </Typography>
                            <Typography variant="h6">
                                {formatNumber(stats.unchangedClusters)}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Typography variant="body2" color="text.secondary">{t("Expanded Clusters")}

              </Typography>
                            <Typography variant="h6">
                                {formatNumber(stats.expandedClusters)}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Typography variant="body2" color="text.secondary">{t("Changed Clusters")}

              </Typography>
                            <Typography variant="h6">
                                {formatNumber(stats.changedClusters)}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Typography variant="body2" color="text.secondary">{t("New Clusters")}

              </Typography>
                            <Typography variant="h6">
                                {formatNumber(stats.newClusters)}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>

                {stats.mergedProfilesUpdated !== undefined && stats.mergedProfilesUpdated > 0 &&
        <Box sx={{ mt: 3 }}>
                        <Typography variant="body2" color="text.secondary">{t("Merged Profiles Updated")}

          </Typography>
                        <Typography variant="h6">
                            {formatNumber(stats.mergedProfilesUpdated)}
                        </Typography>
                    </Box>
        }
            </CardContent>
        </Card>);

};

export default MergingPhaseCard;
